import { render } from "./TalentBenchModal.vue?vue&type=template&id=95da30ea"
import script from "./TalentBenchModal.vue?vue&type=script&lang=js"
export * from "./TalentBenchModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__